import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { ReactElement } from 'react';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';

interface ProductCodesTooltipProps {
  children: ReactElement;
  productCode: string;
  productReferenceCode?: string;
  showTooltipContent?: boolean;
  tabIndex?: number;
}

const ProductCodesTooltip = ({
  children,
  productCode,
  showTooltipContent,
  productReferenceCode,
  tabIndex,
}: ProductCodesTooltipProps) => {
  const { translate } = useTranslation();

  if (!showTooltipContent) {
    return children;
  }

  return (
    <Tooltip
      tabIndex={tabIndex}
      TooltipContent={
        <div style={{ display: 'flex', columnGap: '8px' }}>
          <div>
            <Typography
              variant="body2"
              sx={(theme) => ({ fontWeight: theme.typography.fontWeightLight })}
            >
              {translate(LangEnum.GLOBAL_CODE)}
            </Typography>
            {productReferenceCode && (
              <Typography
                variant="body2"
                sx={(theme) => ({ fontWeight: theme.typography.fontWeightLight })}
              >
                {translate(LangEnum.GLOBAL_REFERENCE)}
              </Typography>
            )}
          </div>
          <div>
            <Typography variant="body2">{productCode}</Typography>
            <Typography variant="body2">{productReferenceCode}</Typography>
          </div>
        </div>
      }
    >
      {children}
    </Tooltip>
  );
};

export default ProductCodesTooltip;
